import React from 'react';
import logo from '../../assets/images/ascasSVG.svg';
import './figmaheader.scss';
const FigmaHeader = ({editedDate}) => {
  let date = new Date();
  let todayDate = editedDate ? editedDate : `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
  return (
    <div className='mainFigmaHeader'>
      <div className='HeaderContainer'>
        <div className='imgContainer1'>
          <img src={logo} alt='' />
        </div>
        <div>
          <div className='locationContainer'>
            <p>Accumed Speciality Clinic and Scans</p>
            <span>
              24, Chowdry Nagar Main Rd, opp. Vasanthi Dental Hospital,
              <br /> Majestic Colony, Valasaravakkam, Chennai, Tamil Nadu 600087
            </span>
          </div>
          <div className='physAndBookContainer'>
            <div>
              <p>Physician specializing in :</p>
              <span>
                Fertility Obstetrics laparoscopy <br />
                Gynecology <br />
                Ultrasound/3D scan
              </span>
            </div>
            <div>
              <p>For Booking Appointment</p>
              <span>
                +91 9342521779 <br />
                044 4793 9484
              </span>
            </div>
          </div>
        </div>
      </div>
      <div style={{textAlign: 'right'}}>
        <section>
          <label style={{fontSize: '14px', fontWeight: '600'}}>Date :</label>
          <span> {todayDate}</span>
        </section>
      </div>
    </div>
  );
};

export default FigmaHeader;
